// Minimal scroll controls for subcategory slider
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-subnav]')?.forEach((root) => {
    const track = root.querySelector('[data-subnav-track]');
    const prev = root.querySelector('[data-subnav-prev]');
    const next = root.querySelector('[data-subnav-next]');
    if (!track) return;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 0);
      if (next) next.toggleAttribute('disabled', track.scrollLeft >= max);
    };
    update();
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    const step = () => Math.max(160, Math.round(track.clientWidth * 0.6));
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  });
});

